<style>
  #dashboardRefreshBtn {
    display: flex;
    width: 1.75rem;
    height: 1.75rem;
    padding: 0.4rem;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    flex-shrink: 0;
    border-radius: 0.375rem;
    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px #0091d9;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .spinning {
    animation: spin 1s linear infinite;
  }
</style>

<script>
  import { createEventDispatcher } from "svelte";

  export let width = 18;
  export let height = 16;
  export let stateStore; // writable with value of state - options: default, hover, active

  const dispatch = createEventDispatcher();

  const backgroundColorMapping = {
    default: "white",
    hover: "#E7E9F0", // Secondary-Light-Grey
    active: "white",
  };
  const borderColorMapping = {
    default: "#E7E9F0", // Secondary-Light-Grey
    hover: "#E7E9F0", // Secondary-Light-Grey
    active: "#0091D9", // Primary-Blue
  };

  let style = "";
  let hover = false;

  stateStore.subscribe((state) => {
    let newState = state;
    if (state === "afterLoad") {
      newState = hover ? "hover" : "default";
    }
    style = `border: 1.5px solid ${borderColorMapping[newState]}; background-color: ${backgroundColorMapping[newState]};`;
  });

  const handleRefreshClick = () => {
    dispatch("refresh-click");
  };

  const handleMouseEnter = () => {
    hover = true;
    if ($stateStore !== "active") {
      stateStore.set("hover");
    }
  };

  const handleMouseLeave = () => {
    hover = false;
    if ($stateStore !== "active") stateStore.set("default");
  };
</script>

<button
  id="dashboardRefreshBtn"
  {style}
  on:click={handleRefreshClick}
  on:mouseenter={handleMouseEnter}
  on:mouseleave={handleMouseLeave}
  aria-label="Refresh Button"
  disabled={$stateStore === "active"}
>
  <!-- fa sync-alt -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {width}
    {height}
    viewBox="0 0 {width} {height}"
    fill="none"
    class:spinning={$stateStore === "active"}
  >
    <path
      d="M3.21443 5.53929C4.17157 3.28929 6.40371 1.71429 9.00014 1.71429C10.418 1.71429 11.7787 2.27857 12.7823 3.28214L14.6466 5.14286H12.7144C12.2394 5.14286 11.8573 5.525 11.8573 6C11.8573 6.475 12.2394 6.85714 12.7144 6.85714H16.7144C17.1894 6.85714 17.5716 6.475 17.5716 6V2C17.5716 1.525 17.1894 1.14286 16.7144 1.14286C16.2394 1.14286 15.8573 1.525 15.8573 2V3.93214L13.9966 2.06786C12.6716 0.742857 10.8751 0 9.00014 0C5.693 0 2.85371 2.00714 1.63585 4.86786C1.45014 5.30357 1.65371 5.80714 2.08943 5.99286C2.52514 6.17857 3.02871 5.975 3.21443 5.53929ZM16.3573 11.1464C16.543 10.7107 16.343 10.2071 15.9073 10.0214C15.4716 9.83572 14.968 10.0357 14.7823 10.4714C13.8216 12.7179 11.593 14.2857 9.00014 14.2857C7.58228 14.2857 6.22157 13.7214 5.218 12.7179L3.35371 10.8571H5.28585C5.76085 10.8571 6.143 10.475 6.143 10C6.143 9.525 5.76085 9.14286 5.28585 9.14286H1.28585C0.810854 9.14286 0.428711 9.525 0.428711 10V14C0.428711 14.475 0.810854 14.8571 1.28585 14.8571C1.76085 14.8571 2.143 14.475 2.143 14V12.0679L4.00371 13.9286C5.32871 15.2571 7.12514 16 9.00014 16C12.3037 16 15.1359 14 16.3573 11.1464Z"
      fill="#0091D9"
    ></path>
  </svg>
</button>
